import { StarvationBidderAlgoConfig } from './types';
import { Platform } from '../users';

import { OfflineSalesOptimizerStrategy } from '@/features/offlineSalesOptimizer';
import { hexToHsl } from '@/shared/utils/utils';

export const OFFLINE_SALES_OPTIMIZER_ALGO_NAME = 'Offline Sales Optimizer';
export const STARVATION_BIDDER_ALGO_NAME = 'Starvation Bidder';

/** Sentinel value for algorithm filters — matches backend NO_ALGORITHM_FILTER_VALUE. */
export const NO_ALGORITHM_APPLIED_FILTER_VALUE = 'none' as const;

export const offlineSalesOptimizerStrategies: Record<
  OfflineSalesOptimizerStrategy,
  { label: string; description: string }
> = {
  maximize_roi: {
    label: 'Maximize ROI irrelevant of Market Share',
    description:
      'BDI is lagging vs CDI, regardless of how strong or weak BDI is',
  },
  maximize_market_share_minimize_decay: {
    label: 'Maximize Market Share while minimizing ROI decay',
    description:
      'Target places with average BDI where BDI is lagging vs CDI, not somewhere with overly low BDI',
  },
  maximize_market_share: {
    label: 'Maximize Market Share irrelevant of ROI',
    description: 'Higher than average BDI',
  },
  velocity: {
    label: 'Velocity',
    description: 'Target places where the lag between BDI & CDI is the highest',
  },
};

export const starvationBidderGoalTypesConfig: Record<
  Platform['name'],
  Partial<
    Record<
      StarvationBidderAlgoConfig['productivityMeasure'],
      {
        label: string;
        isDisabled: boolean;
      }
    >
  >
> = {
  'The Trade Desk': {
    cpm: {
      label: 'CPM (cost per 1000 impressions)',
      isDisabled: false,
    },
    cpcv: {
      label: 'CPCV (cost per completed view)',
      isDisabled: true,
    },
    vcpm: {
      label: 'vCPM (viewable cost per 1000 impressions)',
      isDisabled: true,
    },
  },
  DV360: {
    cpm: {
      label: 'CPM (cost per 1000 impressions)',
      isDisabled: false,
    },
    cpcv: {
      label: 'CPCV (cost per completed view)',
      isDisabled: true,
    },
    vcpm: {
      label: 'vCPM (viewable cost per 1000 impressions)',
      isDisabled: true,
    },
  },
  Meta: {
    cpv: {
      label: 'CPV (Cost Per View)',
      isDisabled: false,
    },
    cpe: {
      label: 'CPE (cost per engagement)',
      isDisabled: true,
    },
    cpm: {
      label: 'CPM (cost per 1000 impressions)',
      isDisabled: false,
    },
    cpcv: {
      label: 'CPCV (cost per completed view)',
      isDisabled: true,
    },
    vcpm: {
      label: 'vCPM (viewable cost per 1000 impressions)',
      isDisabled: true,
    },
  },
  TikTok: {
    cpm: {
      label: 'CPM (cost per 1000 impressions)',
      isDisabled: false,
    },
    cpv: {
      label: 'CPV (Cost Per View)',
      isDisabled: false,
    },
    cpcv: {
      label: 'CPCV (cost per completed view)',
      isDisabled: false,
    },
  },
};

export function getAlgorithmChipColor(color: string, mode: 'light' | 'dark') {
  const { h, s } = hexToHsl(color);
  if (mode === 'light') {
    return {
      bgColor: `hsl(${String(h)}, ${String(s * 0.6)}%, 94%)`,
      text: `hsl(${String(h)}, ${String(s)}%, 35%)`,
    };
  }

  return {
    bgColor: `hsl(${String(h)}, ${String(s * 0.35)}%, 22%)`,
    text: `hsl(${String(h)}, ${String(s * 0.7)}%, 80%)`,
  };
}
